// Use the current window origin for API calls so cookies work on any domain (iomsl.com, melodrop-4.emergent.host, etc.)
// Falls back to REACT_APP_BACKEND_URL for preview environment
const getApiBase = () => {
  if (typeof window !== 'undefined' && window.location.origin) {
    // In production, use same-origin to avoid cross-domain cookie issues
    return window.location.origin;
  }
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const API_BASE = getApiBase();
export const API = `${API_BASE}/api`;

// Normalize any URL that contains /api/files/ to use relative path
// This ensures images/audio work on any domain (iomsl.com, preview, localhost)
export const normalizeUrl = (url) => {
  if (!url || typeof url !== 'string') return url;
  // Already relative
  if (url.startsWith('/api/')) return url;
  // Extract relative path from absolute URL
  const match = url.match(/(\/api\/files\/.+)$/);
  if (match) return match[1];
  return url;
};

// Convert any value into a usable URL: relative /api/ paths, raw storage paths (mixtape covers,
// album covers, etc.) all get normalized to a fully-qualified URL on the current domain.
export const toFullUrl = (url) => {
  if (!url || typeof url !== 'string') return url;
  // Already a full http(s) URL — return unchanged
  if (/^https?:\/\//i.test(url)) return url;
  // Data URL / blob — pass through
  if (url.startsWith('data:') || url.startsWith('blob:')) return url;
  const relative = normalizeUrl(url);
  if (relative.startsWith('/api/')) return `${API_BASE}${relative}`;
  // Raw storage path (e.g. "melodrop/covers/abc.jpg") → serve via /api/files/
  if (!relative.startsWith('/')) return `${API_BASE}/api/files/${relative}`;
  return `${API_BASE}${relative}`;
};
